import { OilBlockDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as OilBlockActions from './oil-block.actions';

export const OIL_BLOCK_FEATURE_KEY = 'oilblock';

export interface OilBlockState extends EntityState<OilBlockDto> {
  selectedOilBlockId?: string | number; // which OilBlock record has been selected
  loaded: boolean; // has the OilBlock list been loaded
  error?: string | null; // last none error (if any)
}

export interface OilBlockPartialState {
  readonly [OIL_BLOCK_FEATURE_KEY]: OilBlockState;
}

export const oilBlockAdapter: EntityAdapter<OilBlockDto> = createEntityAdapter<
  OilBlockDto
>({
  selectId: (oilBlock) => oilBlock.id,
  sortComparer: false,
});

export const initialState: OilBlockState = oilBlockAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedOilBlockId: null,
});

const oilBlockReducer = createReducer(
  initialState,
  on(OilBlockActions.loadOilBlock, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(OilBlockActions.loadOilBlockSuccess, (state, { oilBlock }) =>
    oilBlockAdapter.addAll(oilBlock, { ...state, loaded: false })
  ),
  on(OilBlockActions.loadOilBlockFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(OilBlockActions.addOilBlock, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(OilBlockActions.addOilBlockSuccess, (state, { newOilBlock }) =>
    oilBlockAdapter.addMany(newOilBlock, { ...state, loaded: false })
  ),
  on(OilBlockActions.addOilBlockFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(OilBlockActions.updateOilBlock, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(OilBlockActions.updateOilBlockSuccess, (state, { updateOilBlock }) =>
    oilBlockAdapter.upsertMany(updateOilBlock, { ...state, loaded: false })
  ),
  on(OilBlockActions.updateOilBlockFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(OilBlockActions.removeOilBlock, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(OilBlockActions.removeOilBlockSuccess, (state, { ids }) =>
    oilBlockAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(OilBlockActions.removeOilBlockFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: OilBlockState | undefined, action: Action) {
  return oilBlockReducer(state, action);
}
